import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard, Row } from '../../styled';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Button from 'src/components/form/Button';

interface TileAIFProps {
  hasIncidents: boolean;
  meanDaysBetweenIncidents: number | null;
  meanDaysBetweenNearMisses: number | null;
}

export const TileAIF: React.FC<TileAIFProps> = ({
  hasIncidents,
  meanDaysBetweenIncidents,
  meanDaysBetweenNearMisses,
}) => {
  return (
    <BaseCard>
      <span className="c-title">Average Incident Frequency</span>
      <div style={{ flex: 1 }} />
      {hasIncidents ? (
        <div>
          <Row>
            <Poppins px={14} weight={500} nowrap>
              Mean time between incidents
            </Poppins>
            <div className="separator" />
            {_.isNil(meanDaysBetweenIncidents) ? (
              <Poppins weight={600} color="gp1" px={14}>
                N/A
              </Poppins>
            ) : (
              <Poppins weight={600} color="gp1" px={14}>
                {meanDaysBetweenIncidents} days
              </Poppins>
            )}
          </Row>

          <Row>
            <Poppins px={14} weight={500} nowrap>
              Mean time between near misses
            </Poppins>
            <div className="separator" />
            {_.isNil(meanDaysBetweenNearMisses) ? (
              <Poppins weight={600} color="gp1" px={14}>
                N/A
              </Poppins>
            ) : (
              <Poppins weight={600} color="gp1" px={14}>
                {meanDaysBetweenNearMisses} days
              </Poppins>
            )}
          </Row>
        </div>
      ) : (
        <>
          <div style={{ flex: 1 }} />
          <Link to="/incidents">
            <Button primary>+ Add Incident</Button>
          </Link>
        </>
      )}
    </BaseCard>
  );
};
